import { FaTimesCircle } from "react-icons/fa";
import {
  formatDateTimeToLocale,
  formatKES,
  getDisplayValue,
} from "../../../../utils/transactionutils";
import { contactSupport } from "../../../../utils/supportUtils";
import CustomButton from "../../../ui/CustomButton/CustomButton";
import CustomNotificationBanner from "../../../ui/CustomNotificationBanner/CustomNotificationBanner";
import {
  FundsSafeMessage,
  ResultStatusIcon,
  SummaryRow,
  TransactionDetailsCard,
} from "../../../shared/result/ResultPrimitives";

export function FailedView({
  businessName,
  accountNumber,
  transactionAmount,
  transactionFee,
  transactionReference,
  verifiedAlias,
  aliasLabel,
  remarks,
  createdDate,
  newBalance,
  walletBalance,
  onNewPayment,
}) {
  const currentBalance = newBalance ?? walletBalance;

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex flex-col items-center text-center gap-3">
        <ResultStatusIcon
          icon={FaTimesCircle}
          bgClassName="bg-red-50"
          iconClassName="text-red-500"
        />
        <p className="text-sm sm:text-base font-semibold text-red-600">
          Payment Failed!
        </p>
        <p className="text-sm text-gray-600">
          Your payment to{" "}
          <span className="font-semibold text-gray-900">
            {getDisplayValue(businessName)}
          </span>{" "}
          could not be processed.
        </p>
      </div>

      <div className="w-full max-w-sm mx-auto">
        <CustomNotificationBanner
          variant="error"
          title="Reason:"
          titleColor="var(--mantine-color-red-6)"
          message={remarks}
          withCloseButton={false}
        />
      </div>

      <FundsSafeMessage
        amount={formatKES(transactionAmount)}
        balance={formatKES(currentBalance)}
      />

      <TransactionDetailsCard>
        {transactionReference && (
          <SummaryRow
            label="Transaction ID"
            value={transactionReference}
            stacked
          />
        )}
        <SummaryRow
          label="Attempted Transaction"
          value={formatKES(transactionAmount)}
        />
        {createdDate && (
          <SummaryRow
            label="Date"
            value={formatDateTimeToLocale(createdDate)}
          />
        )}
        <SummaryRow label={aliasLabel} value={verifiedAlias ?? "—"} />
        {accountNumber && (
          <SummaryRow label="Account Number" value={accountNumber} />
        )}
        <SummaryRow label="Transaction Fee" value={formatKES(transactionFee)} />
        <SummaryRow label="Current Balance" value={formatKES(currentBalance)} />
      </TransactionDetailsCard>

      <div className="w-full max-w-sm mx-auto flex gap-2">
        <CustomButton
          color="primary"
          radius="md"
          className="flex-1"
          onClick={onNewPayment}
        >
          Try Again
        </CustomButton>
        <CustomButton
          variant="outline"
          color="gray"
          radius="md"
          className="flex-1"
          onClick={() => contactSupport()}
        >
          Contact Support
        </CustomButton>
      </div>
    </div>
  );
}
